import { useEffect, useState } from "react";
import {currency} from "Components/MUI_components/currencyFormatterTag"
import Loading from "Components/MUI_components/loading";
import {
  List,
  ListItem,
  ListItemText,
  Paper,
  Button,
  TextField,
  Radio,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { styled } from "@mui/material/styles";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";
import { PAYMENT_STATUS_COLOR_CODE } from "Components/Constants/PaymentStatusColorCode";
import { Edit } from "@mui/icons-material";
import { MULTI_PURPOSE_STATUS } from "Components/Constants/MultiPurposeStatus";
import AcUnitIcon from '@mui/icons-material/AcUnit';

const PREFIX = "RecentSales";
const classes = {
  root: `${PREFIX}-root`,
};
const Root = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function RecentSales(props) {
  const { data, fetchRecentInvoice, invoiceRecall } = props;
  const [invoiceNumber, setInvoiceNumber] = useState("");



  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    fetchRecentInvoice();
    return () => {
      controller.abort();
    };
  }, []);

  const handleSubmit = async () => {
    if (invoiceNumber) {
      await fetchRecentInvoice(invoiceNumber);
    }
  };
  const handleClear = async () => {
    setInvoiceNumber("");
    await fetchRecentInvoice();

  };

  return (
    <Root>

      {/* 
      <div className="row mt" style={{ textAlign: 'center' }}>
        <FormControl
          control="radio"
          options={RadioOptions}
          name="series"
        />
      </div> */}


      <div className="flex mt">
        <TextField
          value={invoiceNumber}
          onChange={(e) => setInvoiceNumber(e.target.value)}
          label="Invoice Number"
          fullWidth
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSubmit();
          }}
        />
        <Button
          variant="contained"
          onClick={handleSubmit}
          color="info"
          style={{ margin: "0 5px" }}
        >
          find
        </Button>
        <Button
          variant="contained"
          onClick={handleClear}
          color="error"
          style={{
            margin: "0 5px"
          }}
        >
          Clear
        </Button>
      </div>

      <List className={classes.root}>
        {data.map((item, index) => (
          <ListItem
            alignItems="flex-start"
            style={{
              backgroundColor: item.status == MULTI_PURPOSE_STATUS.REVERSED ? PAYMENT_STATUS_COLOR_CODE.REVERSED : item.paidStatus == PAYMENT_STATUS_CODE.PAYMENT_COMPLETED
                ? PAYMENT_STATUS_COLOR_CODE.PAYMENT_COMPLETED : item.paidStatus == PAYMENT_STATUS_CODE.PAYMENT_PARTIAL
                  ? PAYMENT_STATUS_COLOR_CODE.PAYMENT_PARTIAL : PAYMENT_STATUS_COLOR_CODE.PAYMENT_NOT_DONE,
            }}
            className="list-item"
            key={index}
            onDoubleClick={() => {
              invoiceRecall(item.code);
            }}
          >
            <ListItemText
              primary={
                <span className="space-between">
                  <span style={{ fontSize: 12 }}> Invoice : {item.code} </span>
                  &nbsp; &nbsp;
                  <span style={{ fontSize: 12 }}>{item.dateTime}</span>
                </span>
              }
              secondary={
                <span className="space-between">
                  <span>
                  {item.isFreeze == true ? <AcUnitIcon fontSize="14"/> : "" 	}
                    {item.status == MULTI_PURPOSE_STATUS.REVERSED ?

                      <CompareArrowsIcon
                        fontSize="14"
                        style={{ margin: "0 10px", color: "#2c2c2c" }}
                      />
                      :
                      item.paidStatus == PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE ?
                        <Edit
                          fontSize="14"
                          style={{ margin: "0 10px", color: "blueviolet" }}
                        />
                        :
                        <LockIcon
                          fontSize="14"
                          style={{ margin: "0 10px", color: "crimson" }}
                        />
                    }
                      Rs. {currency(item.totalAmount)}
                  </span>
                  {/* <span>
                    {item.paidStatus == PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE ? (
                      <Edit
                        fontSize="14"
                        style={{ margin: "0 10px", color: "blueviolet" }}
                      />
                    ) : (
                      <LockIcon
                        fontSize="14"
                        style={{ margin: "0 10px", color: "crimson" }}
                      />
                    )}
                    Rs. {currency(item.totalAmount)}
                  </span> */}
                  &nbsp; &nbsp;
                  <span style={{ fontSize: 12, fontWeight: "bold" }}>
                    {item.customer ? item.customer.firstName : "Cash"}
                  </span>
                </span>
              }
            />
          </ListItem>
        ))}
        {!data.length && (
          <>
            <Loading noIcon text="" height={200} />
          </>
        )}
      </List>
    </Root>
  );
}
